<template>
    <div class="catalog-root" v-if="$route.path==='/'">
        <v-btn id="cat-nav-btn" class="text_navbar hidden-sm-and-down"
               @click="catalog_open"
               flat dark>
            <span>Каталог</span>
            <v-icon right medium>view_list</v-icon>
        </v-btn>
        <v-btn id="mob-cat-nav-btn" class="text_navbar hidden-md-and-up"
               @click="catalog_open"
               flat dark icon>
            <v-icon>view_list</v-icon>
        </v-btn>
    <v-dialog
            v-model="dialog_catalog"
            fullscreen hide-overlay
            transition="dialog-bottom-transition">
    <v-card class="mx-auto" width="100%">
        <v-toolbar fixed class="bg_navbar">
            <v-btn class="accent hidden-sm-and-down"
                   @click="toggle_catalog_all"
                   flat dark>
                <v-icon>folder_open</v-icon>
                <span>Показать весь каталог</span>
            </v-btn>
            <v-btn class="accent hidden-md-and-up"
                   @click="toggle_catalog_all"
                   flat dark>
                <span>Весь кат.</span>
            </v-btn>
            <v-btn :disabled="selected.length === 0" class="primary hidden-sm-and-down"
                   @click="toggle_catalog_to_selected"
                   flat dark>
                <v-icon>check_box</v-icon>
                <span>Показать товары для выбранных [{{selected.length}}]</span>
            </v-btn>
            <v-btn :disabled="selected.length === 0" class="primary hidden-md-and-up"
                   @click="toggle_catalog_to_selected"
                   flat dark>
                <span>Выбран. [{{selected.length}}]</span>
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn icon @click="catalog_close()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-sheet class="pa-3 secondary" style="padding-top: 64px !important;">
            <v-layout row wrap justify-space-between fill-height>
                <v-text-field
                        v-model="search"
                        label="Поиск раздела"
                        dark flat solo-inverted hide-details clearable
                        clear-icon="backspace"
                ></v-text-field>
            </v-layout>
            <v-layout row wrap justify-space-between fill-height>
                <v-flex>
                    <v-checkbox color="primary lighten-2"
                                v-model="caseSensitive" dark hide-details label="С учетом регистра"
                    ></v-checkbox>
                </v-flex>
            </v-layout>
        </v-sheet>
            <v-layout row wrap align-center justify-start>
                <v-flex xs6 sm4 md3>
                    <v-btn small flat @click="toggle_catalog_expand" class="secondary--text">
                        <v-icon left>{{open.length > 0 ? 'vertical_align_top' : 'vertical_align_bottom'}}</v-icon>
                        <span class="hidden-sm-and-down">{{open.length > 0 ? 'Свернуть все' : 'Развернуть все'}}</span>
                        <span class="hidden-md-and-up">{{open.length > 0 ? 'Сверн. все' : 'Разверн. все'}}</span>
                    </v-btn>
                </v-flex>
                <v-flex xs6 sm4 md3>
                    <v-btn small flat :disabled="selected.length === 0"
                           @click="selected = []" class="secondary--text">
                        <v-icon left>check_box_outline_blank</v-icon>
                        <span class="hidden-sm-and-down">Снять выделение</span>
                        <span class="hidden-md-and-up">Снять выд.</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        <v-container grid-list-md fluid>
            <v-card-text>
                <v-treeview
                        :items="items" :search="search" :filter="filter" :open.sync="open"
                        selectable v-model="selected"
                        selected-color="primary" return-object
                        expand-icon="" hoverable open-on-click
                        id="treeView"
                        style=" width: 95%; white-space: nowrap; overflow-x: hidden;
                        text-overflow: clip;"
                >
                    <template slot="prepend" slot-scope="{ item, open }">
                        <v-icon v-if="item.children && item.children.length > 0">
                            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                        </v-icon>
                    </template>
                    <template slot="label" slot-scope="{ item }">
                        <v-tooltip top v-if="item.name.length >= 50">
                            <template #activator="data">
                                <span class="body-1" v-on="data.on">{{item.name}}</span>
                            </template>
                            <span>{{item.name}}</span>
                        </v-tooltip>
                        <span v-else class="body-1">{{item.name}}</span>
                        <span v-if="item.goods_count > 0"> [{{item.goods_count}}]</span>
                    </template>
                </v-treeview>
            </v-card-text>
        </v-container>
    </v-card>

    </v-dialog>
    </div>
</template>

<script>
    import $ from 'jquery';
    import { Globals } from '@/globals.js';
    export default {
        name: "CatalogRoot",
        data() {
            return {
                items: [],
                open: [],
                selected: [],
                all_catalogs: [],
                search: null,
                caseSensitive: false
            }
        },
        computed: {
            filter() {
                return this.caseSensitive
                    ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                    : undefined
            },
            selected_catalogs() { return this.$store.getters.selected_catalogs },
            dialog_catalog() { return this.$store.getters.catalog_opened_get },
        },
        created() {
            this.load_catalog();
            this.selected = this.selected_catalogs.items;
        },
        methods: {
            load_catalog() {
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'catalog/structure/',
                    type: 'GET',
                    success: (response) => {
                        this.items = response;
                        this.all_catalogs = [];
                        this.get_all_catalogs(this.items);
                    }
                })
            },
            get_all_catalogs(obj) {
                for (var x in obj) {
                    if (typeof obj[x] === 'object') {
                        this.get_all_catalogs(obj[x]);
                    } else if (x === 'id') {
                        this.all_catalogs.push(obj);
                    }
                }
            },
            // Controls
            toggle_catalog_expand() {
                if (this.open.length > 0)
                    this.open = [];
                else {
                    this.open = this.all_catalogs;
                }
            },
            // Selects
            toggle_catalog_all() {
                var catalogs = {
                    all: true,
                    items: [],
                    selected_ids: [],
                };
                // clear selected items
                this.selected = [];
                this.$store.dispatch('selected_catalog_set', catalogs);
                this.$eventBus.$emit('EVENT_price_view_catalog');
                this.catalog_close();
            },
            toggle_catalog_to_selected(){
                var catalogs = {
                    all: false,
                    items: this.selected,
                    selected_ids: this.get_ids_recursively(this.selected, []),
                };
                this.$store.dispatch('selected_catalog_set', catalogs);
                this.$eventBus.$emit('EVENT_price_view_catalog');
                this.catalog_close();
            },
            get_ids_recursively(objs, ids) {
                objs.forEach(function(obj) {
                    if (obj.goods_count > 0)
                        ids.push(obj.id);
                });
                return ids;
            },
            // Start
            catalog_open() {
                this.$store.dispatch('catalog_open');
                this.selected = this.selected_catalogs.items;
            },
            catalog_close() {
                this.$store.dispatch('catalog_close');
            }
        },
    }
</script>

<style scoped>
</style>